// modules/Buyer.js
import React from 'react'

import {Link} from "react-router"
import NavLink from './NavLink'


export default React.createClass({
  render() {
    return (
      <div>
      <div className="sub-navigation">
            <ul>
    
          <li><NavLink to="/viewaddresshistory/buyerviewhistory">View Buyer History</NavLink></li>
          <li><NavLink to="/buyer/buyerviewhistory">View Seller History</NavLink></li>
          <li><NavLink to="/buyer/buyerviewhistory">View Escrow History</NavLink></li>
        </ul>
        
      </div>
      {this.props.children}
      </div>
    )
  }
})


// WEBPACK FOOTER //
// ./src/ViewAddressHistory.js